module.exports = __webpack_public_path__ + "img/s4-3-ja.1a27f381.jpg";